import { MDBCard, MDBCardBody, MDBCol, MDBIcon, MDBBadge } from "mdbreact";

const Physicians = ({ cards = [] }) => {
  return (
    <MDBCol md="12" className="mb-4">
      <MDBCard className="mb-3">
        <MDBCardBody>
          <div className="d-flex justify-content-between align-items-center flex-wrap mb-3">
            <div>
              <h5 className="mb-1 font-weight-bold">Consulting Physicians</h5>
              <div className="text-muted small">
                Physicians and clinics currently tagged to this secretary.
              </div>
            </div>
            <div className="text-info font-weight-bold">
              {cards.length} tagged physician{cards.length === 1 ? "" : "s"}
            </div>
          </div>

          <div className="row">
            {cards.length ? (
              cards.map((item) => (
                <div className="col-md-6 col-xl-4 mb-3" key={item.id}>
                  <MDBCard className="h-100 border">
                    <MDBCardBody>
                      <div className="d-flex justify-content-between align-items-start mb-2">
                        <div className="pr-2">
                          <div className="font-weight-bold">
                            {item.name || "Unnamed physician"}
                          </div>
                          <div className="text-muted small">
                            {item.specialization}
                          </div>
                        </div>
                        <MDBBadge color={item.statusColor}>
                          {item.statusLabel}
                        </MDBBadge>
                      </div>

                      <div className="small">
                        <div className="mb-1">
                          <MDBIcon
                            icon="clinic-medical"
                            className="mr-2 text-primary"
                          />
                          <strong>{item.clinicTitle}</strong>
                        </div>
                        <div className="mb-1">
                          <MDBIcon
                            icon="calendar-alt"
                            className="mr-2 text-info"
                          />
                          {item.scheduleCount} active schedule
                          {item.scheduleCount === 1 ? "" : "s"}
                        </div>
                        <div className="mt-2 pt-2 border-top">
                          {(item.scheduleDetails || []).length ? (
                            item.scheduleDetails.map((schedule, index) => (
                              <div
                                key={`${item.id}-schedule-${index}`}
                                className="mb-2 pb-2 border-bottom"
                              >
                                <div className="font-weight-bold text-dark">
                                  <MDBIcon
                                    icon="clock"
                                    className="mr-2 text-secondary"
                                  />
                                  {schedule.label}
                                </div>
                                <div className="text-muted">
                                  <MDBIcon
                                    icon="stethoscope"
                                    className="mr-2 text-info"
                                  />
                                  {schedule.type}
                                </div>
                                <div className="text-muted">
                                  <MDBIcon
                                    icon="map-marker-alt"
                                    className="mr-2 text-danger"
                                  />
                                  {schedule.location}
                                </div>
                              </div>
                            ))
                          ) : (
                            <div className="text-muted">
                              No detailed schedule available yet.
                            </div>
                          )}
                        </div>
                      </div>
                    </MDBCardBody>
                  </MDBCard>
                </div>
              ))
            ) : (
              <MDBCol>
                <div className="text-muted text-center py-4">
                  No tagged physician found for this secretary account in the
                  active branch.
                </div>
              </MDBCol>
            )}
          </div>
        </MDBCardBody>
      </MDBCard>
    </MDBCol>
  );
};

export default Physicians;
